import { API_BASE } from './jobIntake';

// Part C: where a company user lands after signing in — My interviews for someone who only interviews (the Interview
// permission, not an admin, no job to recruit on, approve or own); the user dashboard otherwise. Falls back to the
// dashboard if the check fails.
export async function companyUserHome(token) {
  try {
    const res = await fetch(`${API_BASE}/api/my-interviews/summary`, { headers: { Authorization: `Bearer ${token}` } });
    const d = res.ok ? await res.json() : null;
    return d && d.interviewer_only ? '/my-interview-rounds' : '/dashboard/user';
  } catch (e) {
    return '/dashboard/user';
  }
}
